export class Details {
    
      constructor(
        public firstName: string,
        public lastName: string,
        public email: string,
        public ssn: string,
        public dob: string,
        public password:string,
        public password1:string,
        public password2:string,
        public password3:string,
        public password4:string,
        public password5:string,
        public confirmPassword:string,
        public phone:number,
        public security1:{
          question:string,
          answer:string
        },
        public security2:{
          question:string,
          answer:string
        },
        public security3:{
          question:string,
          answer:string
        },
        public passwordChange:Boolean,
        public username:String
      ) {  }
    
    }


// WEBPACK FOOTER //
// ./src/app/login/details.ts